
// export const logout = ( state ) => {
// }

export const setPlaces = (state, places) => {
    state.places = places
}

export const setPlacesSelectable = (state, places) => {
    state.placesSelectable = places
}

export const setPlacesPaginated = (state, placesPaginatedData) => {
    state.placesPaginatedData = placesPaginatedData
}

export const setPlaceDetail = (state, place) => {
    state.place = place
}

export const saveNewPlaces = (state, place) => {
    state.places.unshift(place)
    state.createdData = place;
}

export const saveUpdatedPlace = (state, place) => {
    state.places.unshift(place)
    state.updatedData = place;
}

export const setDeletePlace = (state, place) => {
    
    state.placesPaginatedData.data.filter(x => x.id !== place.id);
    state.deletedData = place
}

export const setPlaceIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setPlaceIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setPlaceIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setPlaceIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
